export default {
  name: {
    target: '[data-validate-name]',
    message: 'Preencha seu nome completo.',
    priority: 5,
    halt: true,
  },
  email: {
    target: '[data-validate-email]',
    message: 'Verifique se o e-mail está digitado corretamente.',
    priority: 5,
    halt: true,
  },
  verifyEmail: {
    target: '[data-validate-verify-email]',
    message: 'Insira um e-mail válido.',
    priority: 2,
    halt: true,
  },
  password: {
    target: '[data-validate-password]',
    message: null,
    priority: 5,
    halt: true,
  },
  cpf: {
    target: '[data-validate-cpf]',
    message: 'Verifique se seu CPF está digitado corretamente.',
    priority: 5,
    halt: true,
    mask: '999.999.999-99',
  },
  cellphone: {
    target: '[data-validate-cellphone]',
    message: 'Celular no formato inválido.',
    priority: 5,
    halt: true,
    mask: ['(99) 9999-9999', '(99) 99999-9999'],
  },
  birthdate: {
    target: '[data-validate-birthdate]',
    message: 'Data inválida.',
    priority: 5,
    halt: true,
    mask: '99/99/9999',
  },
  minage: {
    target: '[data-validate-minage]',
    message: 'Você precisa ter 18 anos para continuar.',
    priority: 5,
    halt: true,
    mask: '99/99/9999',
  },
  maxage: {
    target: '[data-validate-maxage]',
    message: 'Duvido você ter essa idade :p',
    priority: 5,
    halt: true,
    mask: '99/99/9999',
  },
  cep: {
    target: '[data-validate-cep]',
    message: 'Número do CEP inválido.',
    priority: 5,
    halt: true,
    mask: '99999-999',
  },
  emoji: {
    target: '[data-validate-emoji]',
    message: 'Não é permitido inserir emogi.',
    priority: 5,
    halt: true,
  },
  rg: {
    target: '[data-validate-rg]',
    message: 'Número do RG inválido.',
    priority: 5,
    halt: true,
  },
}
